import {
  CheckCircleIcon,
  EllipsisHorizontalCircleIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/20/solid';
import { ignoreDifferenceStateToString } from '../../helpers/util';

interface IgnoreDifferenceStateBadgeProps {
  state: number;
}

export function IgnoreDifferenceStateBadge(
  props: IgnoreDifferenceStateBadgeProps,
) {
  return (
    <span className="flex items-center text-sm text-gray-500">
      {ignoreDifferenceStateToString(props.state) === 'Active' && (
        <CheckCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-green-400"
          aria-hidden="true"
        />
      )}
      {ignoreDifferenceStateToString(props.state) === 'Error' && (
        <ExclamationCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-red-400"
          aria-hidden="true"
        />
      )}
      {ignoreDifferenceStateToString(props.state) === 'Pending' && (
        <EllipsisHorizontalCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
          aria-hidden="true"
        />
      )}
      {ignoreDifferenceStateToString(props.state)}
    </span>
  );
}
